/* eslint-disable @typescript-eslint/naming-convention */
import * as _ from 'lodash';
import moment from 'moment';
import { VehicleActivityType } from './vehicle-activity-type';

export class VehicleBlockActivityInfo {
    trafficDate: Date;
    inventoryNumber: string;
    omsBlockNumber: string;
    startTime: string;
    endTime: string;
    type: VehicleActivityType;
    vehicleActivityId: string;
    routeName?: string;
    routePublicName?: string;
    tripNumber?: string;
    tripDescription?: string;

    startDateTime?: Date;
    endDateTime?: Date;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (obj.type) {
            this.type = parseVehicleActivityType(obj.type);
        }

        if (this.startTime) {
            this.startDateTime = this._parseTrafficDayTimeFormat(this.trafficDate, this.startTime)?.toDate();
        }

        if (this.endTime) {
            this.endDateTime = this._parseTrafficDayTimeFormat(this.trafficDate, this.endTime)?.toDate();
        }
    }

    private _parseTrafficDayTimeFormat(trafficDate: Date, timeString: string) {
        let hours: number; let minutes: number; let seconds = 0;
        const parts = timeString.split(':');
        switch (parts.length) {
            case 3:
                hours = Math.abs(_.toInteger(parts[0]));
                minutes = Math.abs(_.toInteger(parts[1]));
                seconds = Math.abs(_.toInteger(parts[2]));
                break;
            case 2:
                hours = Math.abs(_.toInteger(parts[0]));
                minutes = Math.abs(_.toInteger(parts[1]));
                break;
            default:
                break;
        }

        let date = moment(trafficDate);
        if (hours > 24) {
            hours -= 24;
            date = date.add(1, 'day');
        }

        date = date.add(hours, 'hour').add(minutes, 'minute').add(seconds, 's');
        return date;
    }
}

function parseVehicleActivityType(value: string): VehicleActivityType {
    return VehicleActivityType[value as keyof typeof VehicleActivityType];
}

